import ResourceList from "components/cms/ResourceList";
import useResourceList from "hooks/useResourceList";
import { deleteArticle, listArticles } from "api/article";
import { enText } from "utils/cms";

export default function ArticlesPage() {
  const list = useResourceList({
    list: listArticles,
    remove: deleteArticle,
    confirm: (item) =>
      `Delete article “${enText(item.title) || item.slug}”? This cannot be undone.`,
  });

  return (
    <ResourceList
      title="Articles"
      description="Knowledge Hub articles use one shared template"
      createHref="/admin/articles/new"
      createLabel="New article"
      emptyText="No articles yet. Create one to show it on /resources."
      items={list.items}
      total={list.total}
      loading={list.loading}
      error={list.error}
      toast={list.toast}
      onCloseToast={() => list.setToast(null)}
      deletingId={list.deletingId}
      onDelete={list.onDelete}
      editHref={(item) => `/admin/articles/${item._id}`}
      columns={[
        { key: "title", label: "Title", render: (item) => enText(item.title) || "—" },
        { key: "slug", label: "Slug" },
        {
          key: "category",
          label: "Category",
          render: (item) => enText(item.categoryLabel) || item.categorySlug || "—",
        },
        { key: "publishedAt", label: "Published" },
        { key: "featured", label: "Featured", render: (item) => (item.featured ? "Yes" : "") },
      ]}
    />
  );
}
